
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

class SortArrow extends React.Component {

    _getContainerStyle() {

        if (this.props.size === 'small') {

            return 'arrow-container--small';

        } else {

            return 'arrow-container';
        }
    }

    _getArrowStyle() {

        if (this.props.size === 'small') {

            return 'arrow--small';

        } else {

            return 'arrow';
        }
    }

    _getSortArrow() {

        if (this.props.direction === 'asc') {

            return <span styleName={ this._getArrowStyle() }>&#9650;</span>;

        } else if (this.props.direction === 'desc') {

            return <span styleName={ this._getArrowStyle() }>&#9660;</span>;

        } else {

            return (
                <div>
                    <span styleName={ this._getArrowStyle() }>&#9650;</span>
                    <span styleName={ this._getArrowStyle() }>&#9660;</span>
                </div>
            );
        }
    }

    render() {

        return (
            <div styleName={ this._getContainerStyle() } { ...this.props }>

                { this._getSortArrow() }

            </div>
        );
    }
}

export default CSSModules(SortArrow, style);


// WEBPACK FOOTER //
// ./components/SortArrow/index.js